import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "p-fluid" }
const _hoisted_2 = { class: "p-field p-grid" }
const _hoisted_3 = { class: "p-d-flex p-flex-column p-flex-md-row" }
const _hoisted_4 = { class: "p-fluid" }
const _hoisted_5 = {
  key: 0,
  class: "p-col-12"
}
const _hoisted_6 = {
  key: 1,
  class: "p-col-12"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_specimen_picker_item = _resolveComponent("specimen-picker-item")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.specimens, (item, key) => {
          return (_openBlock(), _createElementBlock("div", {
            key: key,
            class: "p-col-12"
          }, [
            _createVNode(_component_specimen_picker_item, {
              idx: key,
              value: item,
              onSelect: _ctx.select
            }, null, 8, ["idx", "value", "onSelect"])
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (_ctx.specimens.length >= 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(_component_Button, {
                icon: "pi pi-trash",
                iconPos: "left",
                label: _ctx.$t('delete'),
                class: "appButton p-button-raised p-button-danger p-button-sm",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.remove(_ctx.key)))
              }, null, 8, ["label"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.specimens.length < 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(_component_Button, {
                icon: "pi pi-credit-card",
                iconPos: "left",
                label: _ctx.$t('form.add_specimen'),
                class: "appButton p-button-raised p-button-success p-button-sm p-field p-mb-2 p-mr-2",
                onClick: _ctx.add
              }, null, 8, ["label", "onClick"])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 64))
}